import { render, staticRenderFns } from "./GradesEdit.vue?vue&type=template&id=3024156f&scoped=true"
import script from "./GradesEdit.vue?vue&type=script&lang=js"
export * from "./GradesEdit.vue?vue&type=script&lang=js"
import style0 from "./GradesEdit.vue?vue&type=style&index=0&id=3024156f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3024156f",
  null
  
)

export default component.exports